import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleNudgeCandidate01: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleNudgeCandidate02: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleNudgeCandidate03: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleNudgeCandidate04: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleNudgeCandidate05: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleNudgeCandidate06: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleNudgeCandidate07: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate01: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate02: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate03: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate04: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate05: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate06: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate07: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	joinButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	joinButtonNudgeCandidate01: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	joinButtonNudgeCandidate02: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	joinButtonNudgeCandidate03: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	joinButtonNudgeCandidate04: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	joinButtonNudgeCandidate05: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	joinButtonNudgeCandidate06: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	joinButtonNudgeCandidate07: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remindMeLaterButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	notInterestedButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	urgencyTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleJpdNudge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionJpdNudge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleLoomNudge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionLoomNudge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionLoomNudgeWithOneCollaborator: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionLoomNudgeWithTwoCollaborators: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionLoomNudgeWithMoreThanTwoCollaborators: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	getStartedButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	doNotShowAgainButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleNudgeCandidate04Galaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleNudgeCandidate05Galaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate01Galaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate03Galaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate04Galaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate05Galaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionNudgeCandidate07Galaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title',
		defaultMessage: 'Your team is now using Confluence',
		description: 'Title of invite prompt flag to join Confluence',
	},
	titleNudgeCandidate01: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-01',
		defaultMessage: 'Join your teammates in Confluence',
		description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 01',
	},
	titleNudgeCandidate02: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-02',
		defaultMessage: 'Collaborate together in Confluence',
		description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 02',
	},
	titleNudgeCandidate03: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-03',
		defaultMessage: 'Your team is working in Confluence',
		description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 03',
	},
	titleNudgeCandidate04: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04',
		defaultMessage: 'Unify your projects in Confluence',
		description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 04',
	},
	titleNudgeCandidate05: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05',
		defaultMessage: 'Bring projects together in Confluence',
		description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 05',
	},
	titleNudgeCandidate06: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-06',
		defaultMessage: 'Create a single source of truth',
		description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 06',
	},
	titleNudgeCandidate07: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-07',
		defaultMessage: 'Create a single source of truth',
		description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 06',
	},
	description: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description',
		defaultMessage:
			'Organize team knowledge, capture ideas, and share requirements for your Jira projects.',
		description: 'Description of how Confluence can be used to assist with Jira projects',
	},
	descriptionNudgeCandidate01: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01',
		defaultMessage:
			'Create a single source of truth for project decisions and software documentation.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
	descriptionNudgeCandidate02: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-02',
		defaultMessage: 'Capture, consolidate, and share team knowledge, in one centralized place.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
	descriptionNudgeCandidate03: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03',
		defaultMessage:
			'Create project pages to build a shared understanding for better decision-making.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
	descriptionNudgeCandidate04: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04',
		defaultMessage:
			'Organize project information and sync it to Jira tasks to track and hit your goals faster.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
	descriptionNudgeCandidate05: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05',
		defaultMessage:
			'Capture information in project pages and sync to Jira tasks to track your milestones.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
	descriptionNudgeCandidate06: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-06',
		defaultMessage:
			'Consolidate information in one place and sync to Jira tasks for automatic updates.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
	descriptionNudgeCandidate07: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07',
		defaultMessage: 'Join your team in Confluence to consolidate project information in one place.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
	joinButton: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.join-button',
		defaultMessage: 'Join your team',
		description: 'Action to direct access or request access to Confluence',
	},
	joinButtonNudgeCandidate01: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-01',
		defaultMessage: 'Join your team',
		description:
			'Action to direct access or request access to Confluence - multiple text variation exists',
	},
	joinButtonNudgeCandidate02: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-02',
		defaultMessage: 'Join your team',
		description:
			'Action to direct access or request access to Confluence - multiple text variation exists',
	},
	joinButtonNudgeCandidate03: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-03',
		defaultMessage: 'Join your team',
		description:
			'Action to direct access or request access to Confluence - multiple text variation exists',
	},
	joinButtonNudgeCandidate04: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-04',
		defaultMessage: 'Join Confluence',
		description:
			'Action to direct access or request access to Confluence - multiple text variation exists',
	},
	joinButtonNudgeCandidate05: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-05',
		defaultMessage: 'Join Confluence',
		description:
			'Action to direct access or request access to Confluence - multiple text variation exists',
	},
	joinButtonNudgeCandidate06: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-06',
		defaultMessage: 'Join Confluence',
		description:
			'Action to direct access or request access to Confluence - multiple text variation exists',
	},
	joinButtonNudgeCandidate07: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-07',
		defaultMessage: 'Join Confluence',
		description:
			'Action to direct access or request access to Confluence - multiple text variation exists',
	},
	remindMeLaterButton: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.remind-me-later-button',
		defaultMessage: 'Remind me later',
		description: 'Title of the dismiss button in the request access prompt flag',
	},
	notInterestedButton: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.not-interested-button',
		defaultMessage: 'Not interested',
		description:
			'Title of the dismiss button with a stronger tone in the request access prompt flag',
	},
	urgencyTitle: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.urgency-title',
		defaultMessage:
			'{viewCount, select, 0 {Your team is now using Confluence} 1 {Your team is working in Confluence} other {Your team is waiting for you in Confluence}}',
		description: 'Title of invite prompt flag to join Confluence that with increasing urgency',
	},
	titleJpdNudge: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-jpd-nudge',
		defaultMessage: 'Join your team in using Jira Product Discovery',
		description: 'Title of invite prompt flag to join Jira Product Discovery',
	},
	descriptionJpdNudge: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-jpd-nudge',
		defaultMessage:
			'Prioritize ideas, share custom roadmaps, and unify your workflow from discovery to delivery.',
		description:
			'Description of how Jira Product Discovery can be used to assist with Jira projects',
	},
	titleLoomNudge: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-loom-nudge',
		defaultMessage: 'Join your team on Loom',
		description: 'Title of invite prompt flag to join Loom',
	},
	descriptionLoomNudge: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge',
		defaultMessage: 'Use Loom videos to record your screen, demos, and reviews.',
		description: 'Description of how Loom can be used to assist with Jira projects',
	},
	descriptionLoomNudgeWithOneCollaborator: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge-with-one-collaborators',
		defaultMessage:
			'{collaboratorOne} is using Loom videos to record their screen, demos, and reviews.',
		description:
			'Description of how Loom can be used to assist with Jira projects when collaborators are present',
	},
	descriptionLoomNudgeWithTwoCollaborators: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge-with-two-collaborators',
		defaultMessage:
			'{collaboratorOne} and {collaboratorTwo} are using Loom videos to record their screen, demos, and reviews.',
		description:
			'Description of how Loom can be used to assist with Jira projects when collaborators are present',
	},
	descriptionLoomNudgeWithMoreThanTwoCollaborators: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-loom-nudge-with-more-than-two-collaborators',
		defaultMessage:
			'{collaboratorOne} and {collaboratorCount} others are using Loom videos to record their screen, demos, and reviews.',
		description:
			'Description of how Loom can be used to assist with Jira projects when collaborators are present',
	},
	getStartedButton: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.get-started-button',
		defaultMessage: 'Get started',
		description: 'Action to direct access or request access to a product',
	},
	doNotShowAgainButton: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.do-not-show-again-button',
		defaultMessage: "Don't show again",
		description:
			'Title of the dismiss button with a stronger tone in the request access prompt flag',
	},
	titleNudgeCandidate04Galaxia: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04-galaxia',
		defaultMessage: 'Unify your Jira spaces in Confluence',
		description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 04',
	},
	titleNudgeCandidate05Galaxia: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05-galaxia',
		defaultMessage: 'Bring Jira spaces together in Confluence',
		description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 05',
	},
	descriptionGalaxia: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-galaxia',
		defaultMessage:
			'Organize team knowledge, capture ideas, and share requirements for your Jira spaces.',
		description: 'Description of how Confluence can be used to assist with Jira projects',
	},
	descriptionNudgeCandidate01Galaxia: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01-galaxia',
		defaultMessage: 'Create a single source of truth for decisions and documentation.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
	descriptionNudgeCandidate03Galaxia: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03-galaxia',
		defaultMessage: 'Create pages to build a shared understanding for better decision-making.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
	descriptionNudgeCandidate04Galaxia: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04-galaxia',
		defaultMessage:
			'Organize information and sync it to Jira work items to track and hit your goals faster.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
	descriptionNudgeCandidate05Galaxia: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05-galaxia',
		defaultMessage:
			'Capture information in pages and sync to Jira work items to track your milestones.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
	descriptionNudgeCandidate07Galaxia: {
		id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07-galaxia',
		defaultMessage: 'Join your team in Confluence to consolidate information in one place.',
		description:
			'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
	},
});
